import MapModal from './MapModal';
import ZipCodeMap from './ZipCodeMap';

export const components = {
  MapModal,
  ZipCodeMap,
};
